import type { StateCreator } from "zustand";
import type { Chase } from "@/campaigns/modules/chase/types";
import { matchesKey } from "@/campaigns/campaign-key";
import type { AppStore } from "./app.store";

/**
 * The assembled chase views — `campaigns` ⋈ `tournament_progress`, rebuilt by
 * `recomputeChases()` when either stream pushes. The raw progress rows stay in the
 * tournament-progress slice (a chase is a tournament on the wire); this slice only holds the
 * join, like `prizeDrops` and `sprintMissions`.
 */
export interface ChaseSlice {
  chases: Chase[];
  setChases: (chases: Chase[]) => void;
  clearChases: () => void;
}

export const createChaseSlice: StateCreator<ChaseSlice> = (set) => ({
  chases: [],
  setChases: (chases) => set({ chases }),
  clearChases: () => set({ chases: [] }),
});

/** Resolve a chase by its custom_id or numeric id (as string). */
export function selectChaseById(
  state: AppStore,
  key: string
): Chase | undefined {
  return state.chases.find((chase) => matchesKey(chase.campaign, key));
}
